<template>
  <div class="end__outer outro__stage the-end">
    <div class="unm__container">
      <div
        class="welcome__container"
      >
        <h1 class="impact-heading">Experience the Unexpected</h1>
        <div class="unm-player">
          <!-- eslint-disable-next-line -->
          <plyr-youtube :id="this.youtubeID" :crossorigin="true" />
        </div>
        <p class="paragraph paragraph-splash">This is more than our future, it's yours.</p>
        <div class="end__cta-container">
          <a
            href="http://nso.unm.edu/index.html"
            class="checklist__cta end-cta cta-small"
            target="_blank"
          >
            Sign up for New Student Orientation
          </a>
          <a
            href="http://admissions.unm.edu/future-students/freshmen/admitted-student-checklist.html"
            class="checklist__cta end-cta cta-small"
            target="_blank"
          >
            View the Enrollment Checklist
          </a>
          <a
            href="http://housing.unm.edu/living-on-campus/apply-now.html"
            class="checklist__cta end-cta cta-small"
            target="_blank"
          >
            Register for Student Housing
          </a>
          <a
            href="prize.html"
            class="checklist__cta end-cta cta-small"
            target="_blank"
          >
            Claim your Lobo prize
          </a>
          <a
            href="contact.html"
            class="checklist__cta end-cta cta-small"
            target="_blank"
          >
            Contact Admissions
          </a>
        </div>
        <p class="paragraph paragraph-splash">Share the quiz with your family and friends.</p>
        <div class="end__share-container">
          <a

            :href="'http://twitter.com/share?text=The%20University%20of%20New%20Mexico%20-%20Are%20You%20Lobo%20Ready%3F&url=' + url"
            class="social__cta end-cta cta-small"
            target="_blank"
          >
            <svg class="end__share-icon">
              <use xlink:href="/images/icons/twitter-icon.svg#twitter-icon"/>
            </svg>
            <span class="access-hidden">Share to Twitter</span>
          </a>
          <!-- eslint-disable max-len -->
          <a
            :href="'https://www.facebook.com/sharer/sharer.php?u=' + url"
            class="social__cta end-cta cta-small"
            target="_blank"
          >
            <svg class="end__share-icon">
              <use xlink:href="/images/icons/facebook-icon.svg#facebook-icon"/>
            </svg>
            <span class="access-hidden">Share to Facebook</span>
          </a>
          <a
            :href="'mailto:?subject=The%20University%20of%20New%20Mexico%20-%20Are%20You%20Lobo%20Ready%3F&body=' + url"
            class="social__cta end-cta cta-small"
            target="_blank"
          >
            <svg class="end__share-icon">
              <use xlink:href="/images/icons/email-icon.svg#email-icon"/>
            </svg>
            <span class="access-hidden">Share to Email</span>
          </a>
          <a
            :href="'sms:?&body=' + url"
            class="social__cta end-cta cta-small social__cta-message"
          >
            <svg class="end__share-icon">
              <use xlink:href="/images/icons/message-icon.svg#message-icon"/>
            </svg>
            <span class="access-hidden">Share to Messages</span>
          </a>
        </div>
      </div>
    </div>
    <div class="restart__cta-container">
      <div class="restart__cta">
        <button
          class="action-button action-button__turquoise cta-large end__cta"
          @click="refreshPage"
        >
          <span class="action-button__dummy action-button__transparent cta-large end__cta">
            <div class="action-button__shadow"/>
          </span>
          Take the Quiz Again
        </button>
      </div>
    </div>
  </div>
</template>

<script>
  import { mapMutations } from 'vuex';

  import { PlyrVideo, PlyrYoutube } from 'vue-plyr';
  import 'vue-plyr/dist/vue-plyr.css';

  export default {
    name: 'TheEnd',
    components: {
      PlyrVideo,
      PlyrYoutube,
    },
    data() {
      return {
        youtubeID: 'CSPyLnguJmA',
      };
    },
    computed: {
      url() {
        return window.location.origin;
      },
    },
    created() {
      this.setTitle('The End');
    },
    methods: {
      ...mapMutations([
        'setTitle',
      ]),
      refreshPage() {
        window.location.reload(false);
      },
    },
  };
</script>

<style lang="scss">

.end__overlay {
    background-color: $cherry;
}

.unm-player {
  margin-top: 50px;
  margin-bottom: 50px;

  @include breakpoint(large) {
    margin-top: 100px;
    margin-bottom: 100px;
  }
}

.plyr--full-ui.plyr--video .plyr__control--overlaid {
    display: block;
    background: none;
}

.plyr--video .plyr__controls .plyr__control.plyr__tab-focus,
.plyr--video .plyr__controls .plyr__control:hover,
.plyr--video .plyr__controls .plyr__control[aria-expanded=true] {
    background: $cherry;
    color: $white;
}

.plyr__control--overlaid {

  svg {
    display: none;
  }

  &::after {
      position: absolute;
      top: -45px;
      left: -10px;
      width: 60px;
      content: url("/images/icons/play-icon.svg");

      @include breakpoint(large) {
        top: -50px;
        left: -20px;
        width: 90px;
      }

  }
}

.plyr--full-ui input[type=range] {
  color: $cherry;
}

.end__cta-container {
  @include flex-grid-row(12);
  margin-top: 50px;
  margin-bottom: 100px;
}

.end-cta {
  display: inline-block;
  color: $turquoise;
  background-color: $white;
  border-radius: $global-border-radius;
  transition: transform $cta-transition-duration $cta-transition-timing-function;
  transform: scale(1) translateZ(0);
  cursor: pointer;
  outline: 0;

  &:hover,
  &:focus {
    transform: translateZ(0);

    @include breakpoint(large) {
      transform: scale(1.05) translateZ(0);
    }
  }
}

.checklist__cta {
  width: 100%;
  padding: 10px;
  margin-bottom: 15px;

  @include breakpoint(large) {
    width: calc(50% - 20px);
    margin: 10px;
  }
}

.end__share-container {
  margin-top: 40px;
  margin-bottom: 70px;

  @include breakpoint(large) {
    margin-top: 40px;
    margin-bottom: 90px;
  }
}

.social__cta {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  padding: 10px;
  margin-bottom: 15px;

  @include breakpoint(large) {
    width: 70px;
    height: 70px;
    margin: 10px;
  }
}

.end__outer {
    position: relative;
    margin-top: $header_height-small;
    width: 100%;
    padding-top: 70px;

    @include breakpoint(large) {
      margin-top: $header_height-large;
      padding-top: 100px;
    }
}

.end__share-icon {
  fill: $turquoise;
  width: 30px;
  height: 30px;
}

.social__cta-message {
  display: inline-flex;

  @include breakpoint(large) {
    display: none;
  }
}

.restart__cta-container {
  @include z-index(content);
  position: relative;
  width: 100%;
  padding-top: 40px;
  padding-bottom: 40px;
  background-image: url("/images/graphics/blue-texture.png");
  background-repeat: repeat;
  background-size: 50px;

  @include breakpoint(large) {
    padding-top: 70px;
    padding-bottom: 70px;
  }
}

.restart__cta {
  @include flex-grid-row(12);
  @include flex-grid-column(12);
  display: flex;
  justify-content: center;
}

.end__cta {
  @include breakpoint(medium) {
    width: 350px;
  }
}

.the-end {
  &.v-enter,
  &.v-leave-to {
    opacity: 0;
  }

  &.v-enter-active,
  &.v-leave-active {
    transition-duration: $stage-transition-duration;
    transition-property: opacity;
    transition-timing-function: $transition-timing-function;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/TheEnd.vue